import axios from "axios"
import url from "../utils/url";

export const enviarMail = async (mailData) => {
    console.log("esto es mail data", mailData)
    return await axios.post(`${url}/api/sendEmails?from=interno`, mailData)
}

        